import axios from "../axios/index.js";

const urlGetOrderList = "/api/order/get-list";
const urlGetOrderDetail = "/api/order/detail/";
const urlGetOrderCustomer = "/api/order/customer";
const urlGetQuantityByCustomerId = "/api/order/getQuantityByCustomerId";
const urlGetListProductInOrder = "/api/order/getListProductInOrder";

export default {
    getList(params) {
        return axios.get(urlGetOrderList, { 
            params: params
        });
    },

    getOrderCustomer(params) {
        return axios.get(urlGetOrderCustomer, { 
            params: params
        });
    },

    getListProductInOrder(params) {
        return axios.get(urlGetListProductInOrder, { 
            params: params
        });
    },

    getQuantityByCustomerId(id) {
        return axios.get(urlGetQuantityByCustomerId + id);
    },

    getDetail(id) {
        return axios.get(urlGetOrderDetail + id);
    },
};
